module.exports = __webpack_public_path__ + "media/images/top-page_profile@1x-cfcfe12cc1ec0f0bbdfba6010939b20c.jpg";